export default __webpack_public_path__ + "static/sedan_small-7d6130146cb874bd5998c0745035c808.png";